<mat-card>
  <form #vehicleForm="ngForm">

<h2 mat-dialog-title>
  {{ data.mode === 'vehicle-to-owner' ? 'Manage owner vehicles ' + data.id : 'Assign vehicle ownership ' + data.id }}
</h2>

  <!-- HEADER -->
  <mat-toolbar class="vehicle-toolbar">
    <span style="width:90%" *ngIf="data.mode === 'vehicle-to-owner'">Owner</span>
    <span style="width:90%" *ngIf="data.mode === 'owner-to-vehicle'">Vehicles</span>
    <span class="fill-remaining-space"></span>
    <div class="toolbar-actions">
      <button mat-icon-button (click)="cancel()" matTooltip="Close"><mat-icon>close</mat-icon></button>
      <button mat-icon-button color="primary" (click)="confirm()" matTooltip="Save"><mat-icon>save</mat-icon></button>
    </div>
  </mat-toolbar>

  <mat-form-field appearance="outline" style="width:100%">
    <mat-label>Cercar</mat-label>
    <input matInput [(ngModel)]="searchText" (change)="filter()" name="searchText"  placeholder="Find..." (keydown.enter)="$event.preventDefault()">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div style="max-height: 350px; overflow-y: auto;">
    <mat-selection-list>
      <mat-list-option 
        *ngFor="let item of filteredItems"
        [selected]="isSelected(item)"
        (click)="toggleItem(item)">
        <span *ngIf="data.mode === 'vehicle-to-owner'">
          {{ item.value }} - {{ item.text }}
        </span>
        <span *ngIf="data.mode === 'owner-to-vehicle'">
          {{ item.value }}
        </span>
      </mat-list-option>
    </mat-selection-list>
  </div>

  </form>
</mat-card>
